"use client";
import React, { useState } from "react";
import Image from "next/image";

import shape_1 from "@/assets/img/services/shape/services-shape-1.png";
import shape_2 from "@/assets/img/services/shape/services-shape-2.png";
import square_shape_bottom from "@/assets/img/bg/square-shape-bottom.png";
import square_shape_top from "@/assets/img/bg/square-shape-top.png";


import { type accordion_type, default as AccordionBlock} from "./AccordionBlock"
import { type content_type, default as ContentBlock } from "./ContentBlock";

const ghostwriting_content: accordion_type[] = [
    {
      id: 1,
      tab_id: "One",
      question: "Initial author questionnaire and intro call (around 1–2 hours)",
      answer_text: [
        "During this step, I’ll get all the details from you that I can. I’ll want to know your publishing aims and goals for the book, any comparable books on the market you want to share with me, and other background questions, such as who you think your primary audience is.",
        "If you don’t know the answers, we’ll find them together."
      ]

    },
    {
      id: 2,
      tab_id: "Two",
      question: "First interviews and book outline (around 4 hours total)",
      answer_text: [
        "During these first interviews, I’ll ask you more detailed questions as we dive into the topic of your book, mining for gold and emerging with your central theme.",
        "From there, I’ll create your book outline and submit it to you. After a couple of rounds of feedback, we’ll land on the final outline, which will be our map for your story."
      ]
    },
    {
      id: 3,
      tab_id: "Three",
      question: "Interview and chapter 1 (around 2 hours total)",
      answer_text: [
        "Now that we have the book outline nailed down, we’ll focus on the first chapter. I’ll interview you for specifics, and then I’ll go away to my writing cave to craft a first draft.",
        "You’ll review it and give me lots of feedback. I’ll submit a second draft. More feedback. Third draft. Usually by the third draft, we’ve got a solid footing, but if we need more to get it right, this is the time to get picky."
      ]

    },
    {
      id: 4,
      tab_id: "Four",
      question: "Interviews and first half of book (around 8 hours total)",
      answer_text: [
        "With the first chapter solidified, now I can begin work on the first half of the book. I’ll spend some time interviewing you in more detail, and then I’ll go back to my writing cave.",
        "You’ll give me feedback on the first half, then I’ll do a revision."
      ]
    },
    {
      id: 5,
      tab_id: "Five",
      question: "Interviews and second half of book (around 8 hours total)",
      answer_text: [
        "Now we’re really moving! I’ll spend some time interviewing you for the second half, then it’s back to my writing cave.",
        "After another round of feedback, I’ll submit a revised draft."
      ],
    },
    {
      id: 6,
      tab_id: "Six",
      question: "Full book review (around 6 hours total)",
      answer_text: [
        "Now that we have a solid full draft of your book, you’ll do a final review of the whole thing and give me your thoughts. I’ll work on tightening the story, structure, and tone until you’re happy with the final version.",
        "Voila! It’s ready for a final proofread with an editor of your choosing, or I can suggest one from my network."
      ],
    }
  ];


const opening_content: content_type = { 
  title: "What’s the ghostwriting process like?",
  content: ["Every book project is unique, but the approach I follow is roughly the same. Here are the steps and the time required from you."]
}

const closing_content: content_type = {
  title: "Follow-on steps",
  content: ["Depending on your publishing goals, I can advise you on next steps once your book is ready to go."]
}

const GhostwritingQuestionsBlock = () => {
  
  return (
    <section className="pt-40 pb-20 p-relative overlay-bg">
      <ContentBlock content={[ opening_content ]}/>
      <AccordionBlock id="ghostwriting" content={ghostwriting_content} className="pb-40"/>
      <ContentBlock content={[ closing_content ]}/>
      <div className="ab-hero__shape-2">
          <Image src={square_shape_bottom} alt="image-here" />
        </div>
    </section>
  );
};

export default GhostwritingQuestionsBlock;
